<nz-breadcrumb>
  <nz-breadcrumb-item>
    <div style="display: flex; flex-direction: row; align-items: center; width: 100%; ">
      <div style="width: 50%;  display: flex;  flex-direction: row; justify-content: flex-start;">
        <h2> Verification </h2>
      </div>


      <div style="width: 50%;  display: flex;  flex-direction: row; justify-content: flex-end;">
        <button nz-button nzType="primary" class="backbtn" [routerLink]="['/configbot/',id]">
          <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
        </button>
      </div>


      <!-- <nz-icon nzType="right" nzTheme="outline" /> -->

    </div>

  </nz-breadcrumb-item>
</nz-breadcrumb>

<!-- Steps for Bot Progress -->
<nz-steps [nzCurrent]="currentStep" [nzType]="'navigation'">
  <nz-step nzTitle="Bot Details and Experience" [nzStatus]="currentStep > 0 ? 'finish' : 'process'"></nz-step>
  <nz-step nzTitle="Brand Details"></nz-step>
  <nz-step nzTitle="Business Verification"></nz-step>
</nz-steps>


<div class="form-container" *ngIf="currentStep === 0">
  <form nz-form [formGroup]="verifyForm" class="verifyForm">
    <h2>Bot Details & Experience</h2>
    <p>In order to launch a bot, both the Brand and the integrity of the bot must be verified by each carrier. The
      questions on this page help the carrier in understanding and testing the bot's behavior.</p>
    <nz-card style="margin-top: 5px; margin-bottom: 5px;">


      <h3>Bot Interactions</h3>
      <p>This section seeks details on how your bot interacts with users.</p>

      <nz-form-item>
        <nz-form-label [nzSpan]="24">
          <i nz-icon nzType="mail" nzTheme="outline"  style="margin-right: 5px; font-size: 15px; color: red; "></i>
          What actions trigger messages to users?*
        </nz-form-label>
    <p style="margin-left: 25px;" >    When is the first message sent from the agent to the user? Are messages sent at a consistent date/time, do user actions (such as a purchase) trigger messages, or do external triggers (such as package delivery) trigger messages?</p>
        <nz-form-control [nzSpan]="24" style="margin-top: 10px;">
          <textarea nz-input placeholder="Describe the triggers..." rows="3" formControlName="triggerAction"></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24">
          <i nz-icon nzType="message" nzTheme="outline" style="margin-right: 5px; font-size: 15px; color: red;"></i>
          What types of interactions will the bot have with users?*
        </nz-form-label>
       

        <nz-form-control [nzSpan]="24" >
        <p style="margin-left: 25px;">  What are the bot's primary (those that occur most commonly) and secondary (those that are possible but less common) interactions? </p>

          <textarea nz-input placeholder="Describe the interactions..." rows="3"  style="margin-top: 10px;"
            formControlName="botInteractionTypes"></textarea>
        </nz-form-control>
      </nz-form-item>

      <!-- 
    <nz-form-item>
      <nz-form-label [nzSpan]="24">
        <i nz-icon nzType="robot" nzTheme="twotone"></i>
        Does the bot support Conversational flow? Does it respond to P2A messages from users?*
      </nz-form-label>
      <nz-form-control [nzSpan]="24" >
        <nz-radio-group  [(ngModel)]="isCarrierEdited" formControlName="isCarrierEdited">
          <label nz-radio nzValue="true">Yes</label>
          <label nz-radio nzValue="false">No</label>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item> -->
    </nz-card>

    <nz-card nzTitle="Consent Management" style="margin-top: 5px; margin-bottom: 5px;">
      <!-- Consent Opt-in -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24">
          <!-- <i nz-icon nzType="wechat" nzTheme="twotone"  style="margin-right: 5px;"></i> -->
          <i nz-icon nzType="wechat" nzTheme="outline" style="margin-right: 5px; font-size: 15px; color: red;"></i>
          <!-- <nz-icon nzType="wechat" nzTheme="outline" /> -->

          How do you ensure consent, so that only the users who have opted-in will receive messages from your bot?
        </nz-form-label>
  
        <nz-form-control [nzSpan]="24">
          
        <p style="margin-left: 22px;">  Opt-in is critical for approving the bot launch. Provide details for how opt-in is acquired.
          If opt-in is through a website or an app, kindly provide links here.   </p>
          <textarea nz-input placeholder="Provide details for how opt-in is acquired..." rows="3" style="margin-top: 10px;"
            formControlName="optInMessage"></textarea>
        </nz-form-control>
      </nz-form-item>

      <a href="#">Click here to preview the Opt-Out Experience</a>

      <!-- Opt-out Keywords -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24">
          <i nz-icon nzType="mail" nzTheme="outline"  style="margin-right: 5px; font-size: 15px; color: red; "></i>

          What are the opt-out keywords for the bot?
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
        <p style="margin-left: 20px;">  By default, platform recognizes "STOP" as the opt-out keyword. If you would like to configure additional keywords for opt-out, please specify below (use comma separated list, if configuring multiple additional keywords).</p>
          <input nz-input placeholder="Enter opt-out keywords (default: STOP)" formControlName="optOutKeyword" style="margin-top: 10px;" />
        </nz-form-control>
      </nz-form-item>

      <!-- Opt-out Response Message -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24">
          <i nz-icon nzType="robot" nzTheme="outline"  style="margin-right: 5px; font-size: 15px; color: red;"></i>


          What message does the bot send when a user opts out?
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
         <p style="margin-left: 20px;"> Upon receiving an Opt-out request, the platform responds with a 'default message'.
          If you would like to change the response message for an opt-out request, please specify it below. </p>
          <textarea nz-input placeholder="Enter opt-out response message..." rows="2" style="margin-top: 10px;"
            formControlName="optOutMessage"></textarea>
        </nz-form-control>
      </nz-form-item>

      <!-- Opt-out Revoke Keywords -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24">
          <i nz-icon nzType="robot" nzTheme="outline"  style="margin-right: 5px; font-size: 15px; color: red;"></i>

          What keywords can the user send to revoke the opt-out and start receiving messages again?
        </nz-form-label>

        <nz-form-control [nzSpan]="24">
          <p style="margin-left: 20px;">    A user who has opted out, may change their mind and cancel the opt-out request. The platform recognizes "START" as the keyword to cancel an opt-out request.
If you would like to configure additional keywords for cancelling an opt-out, please specify below (use comma separated list, if configuring multiple additional keywords). </p>
          <input nz-input placeholder="Enter keywords (default: START)" formControlName="revokeOptOut" style="margin-top: 10px;">
        </nz-form-control>
      </nz-form-item>

      <!-- Platform or Bot Handling Confirmation -->
      <!-- <nz-form-item>
      <nz-form-label [nzSpan]="24">
        Do you want the platform to handle when a user revokes opt-out?
      </nz-form-label>
      <nz-form-control [nzSpan]="24"  >
        <nz-radio-group  [(ngModel)]="isOptOutByPlatform" formControlName="isOptOutByPlatform">
          <label nz-radio nzValue="true">
            Platform (Developers) sends the Confirmation message
          </label>
          <label nz-radio nzValue="false">
            Bot (Aggregator) sends the Confirmation message
          </label>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item> -->

      <!-- Opt-out Revoke Message -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24">
          <i nz-icon nzType="robot" nzTheme="outline"  style="margin-right: 5px; font-size: 15px; color: red;"></i>

          What message does the bot send when a user revokes opt-out?
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <p style="margin-left: 20px;">    By default, the platform will send the following confirmation message: "Thanks for your request. You will start receiving RCS messages again from this Bot".
If you would like to change this message, please specify it here: </p>
          <textarea nz-input placeholder="Enter revoke confirmation message..." rows="2" style="margin-top: 10px;"
            formControlName="botAccessInstructions">
              </textarea>
        </nz-form-control>
      </nz-form-item>
    </nz-card>


    <nz-card nzTitle="Agent Preview" style="margin-top: 5px;">
      <div>

        <nz-form-item>

          <nz-form-label [nzSpan]="24" nzFor="botInstructions">
            <i nz-icon nzType="robot" nzTheme="outline"  style="margin-right: 5px; font-size: 15px; color: red;"></i>
          
            Bot access instructions</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <p style="margin-left: 20px;">   To test the bot, please specify a wakeup/trigger phrase (e.g. "START"or "Hi"). When received, the bot will start the conversation with the user. Provide a method for reviewers to trigger the bot, such as a website where reviewers can invite and add phone numbers. </p>
            <input nz-input id="botInstructions" placeholder="Enter bot access instructions" style="margin-top: 10px;"
              formControlName="botInteractionTypes" />
          </nz-form-control>
        </nz-form-item>

        <!-- <nz-form-item>
         
          <nz-form-label [nzSpan]="24" nzFor="webhookUrl">
            <span nz-icon nzType="robot" nzTheme="twotone"></span>
            GSMA Chatbot Webhook</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input id="webhookUrl" placeholder="Enter webhook URL" formControlName="webhookUrl"
            />
          </nz-form-control>
        </nz-form-item> -->

        <nz-form-item>

         
        
          <nz-form-label [nzSpan]="24" nzFor="screenshots"><i nz-icon nzType="file-image" nzTheme="outline" style="margin-right: 5px; font-size: 15px; color: red; "></i>

            Screenshots
           
          </nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-upload 
            [nzAction]="apiUrl"
            [nzShowUploadList]="{ showRemoveIcon: true }"
            [nzHeaders]="{ Authorization: token }"
            [nzData]="{ loggedInUserName: userName, fileType: 'Business Name', fileName: fileName }"
            (nzChange)="handleUploadChange2($event)"
            [nzListType]="'picture-card'"
            [nzMultiple]="true"
          >
           
          </nz-upload>
          
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>

          <nz-form-label [nzSpan]="24" nzFor="videoUrl">
            <span nz-icon nzType="link" nzTheme="outline" style="color: #1890ff; margin-right: 5px; font-size: 15px;"></span>
            Video URLs</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <p style="margin-left: 20px;">   If you prefer to review your agent via video, provide comma-separated URLs for a video showing your agent's core functionality and opt-out capabilities. URLs must be publicly accessible.</p>
            <input nz-input id="videoUrl" placeholder="Enter video URLs (comma-separated)" formControlName="videoUrl" style="margin-top: 10px;" >
          </nz-form-control>
        </nz-form-item>


      </div>
    </nz-card>





    <!-- Buttons -->

  </form>
</div>
<!-- second form -->
<div class="form-container" *ngIf="currentStep === 1">

  <form nz-form [formGroup]="brandForm" class="brand-form">
    <!-- Brand Information Section -->
    <nz-card nzTitle="Brand Information" style=" margin-top: 5px; margin-bottom: 5px; ">
      <div nz-row [nzGutter]="24" style="border-top: 2px rgb(225, 225, 225); padding-top: 24px; ">

        <div nz-col [nzSpan]="12" class="form-section">



          <nz-form-item>
            <nz-form-label nz-col [nzSpan]="6" nzFor="brandName" nzLabelAlign="left">Brand Name <span
                style="color: red;"> * </span> </nz-form-label>
            <nz-form-control nz-col nzSpan="16" nzHasFeedback nzErrorTip="Please enter brand name">
              <input id="brandName" nz-input formControlName="brandName" placeholder="Enter Brand Name" />


            </nz-form-control>
          </nz-form-item>

        </div>

        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nz-col [nzSpan]="6" nzFor="officialWebsite" nzLabelAlign="left">Official Website <span
                style="color: red;"> * </span></nz-form-label>
            <nz-form-control nz-col nzSpan="16" nzHasFeedback nzErrorTip="Please enter website URL">
              <input id="officialWebsite" nz-input formControlName="officialWebsite"
                placeholder="https://example.com" />
            </nz-form-control>
          </nz-form-item>
        </div>



        <!-- <div nz-col [nzSpan]="12" class="form-section" >
            <nz-form-item>
              <nz-form-label nz-col [nzSpan]="6" nzLabelAlign="left" nzRequired>Bot Logo</nz-form-label>
              <nz-form-control nzHasFeedback nz-col nzSpan="16" nzErrorTip="Bot Logo!">
                <input type="file" formControlName="botlogo" (change)="onFileSelected($event)" accept=".jpg, .jpeg, .png" />
    
    
              </nz-form-control>
    
            </nz-form-item>
           
          </div> -->

        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nz-col [nzSpan]="6" nzLabelAlign="left">Brand Logo <span style="color: red;"> *
              </span></nz-form-label>

          </nz-form-item>
        </div>


        <!-- <nz-modal [(nzVisible)]="isCropperModalVisible" (nzOnCancel)="closeCropper()" (nzOnOk)="saveCroppedImage()">
            <ng-template #modalTitle>Select an Image</ng-template>
            <ng-template #modalContent>
              <image-cropper
                [imageChangedEvent]="imageChangedEvent"
                [maintainAspectRatio]="true"
                [aspectRatio]="1/1"
                [resizeToWidth]="1000"
                [resizeToHeight]="1000"
                (imageCropped)="imageCropped($event)">
              </image-cropper>
            </ng-template>
          </nz-modal> -->



        <!-- <div  *ngIf="imageUrl" class="preview-container">
          
              <p style=" margin-left: -300px;  margin-top: 10px; display: block;" >Image Preview:</p>
            <img [src]="imageUrl" alt="Bot Logo Preview" class="image-preview" style="max-width: 80px; margin-left: -300px;  margin-top: 10px; display: block;  " />
          </div> -->






        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nz-col [nzSpan]="6" nzFor="industryType" nzLabelAlign="left">Industry Type <span
                style="color: red;"> * </span></nz-form-label>
            <nz-form-control nzHasFeedback nz-col nzSpan="16">
              <nz-select id="industryType" formControlName="industryType" nzPlaceHolder="Select Industry">
                <nz-option nzValue="technology" nzLabel="Technology"></nz-option>
                <nz-option nzValue="retail" nzLabel="Retail"></nz-option>
                <nz-option nzValue="manufacturing" nzLabel="Manufacturing"></nz-option>
                <!-- Add more options as needed -->
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div *ngIf="imageUrl" class="preview-container">
          <p style="margin-left: 40px;">Image Preview:</p>
          <img [src]="imageUrl" alt="Bot Logo Preview" class="image-preview"
            style="margin-left: 45px; max-width: 90px; margin-top: 10px; display: block; border-radius: 10px; box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);" />
        </div>
      </div>
    </nz-card>
    <!-- Contact Person Section -->
    <nz-card nzTitle="Contact Person Information" style="margin-top: 5px; margin-bottom: 5px;">
      <div nz-row [nzGutter]="24" style="border-top: 2px rgb(225, 225, 225); padding-top: 24px; ">

        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nzFor="contactFirstName" nzLabelAlign="left" nz-col [nzSpan]="6">First Name <span
                style="color: red;"> * </span></nz-form-label>
            <nz-form-control nzHasFeedback nz-col nzSpan="16">
              <input id="firstName" nz-input formControlName="firstName" placeholder="Enter First Name" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nzFor="contactLastName" nzLabelAlign="left" nz-col [nzSpan]="6">Last Name <span
                style="color: red;">
                * </span></nz-form-label>
            <nz-form-control nzHasFeedback nzSpan="16">
              <input id="lastName" nz-input formControlName="lastName" placeholder="Enter Last Name" />
            </nz-form-control>
          </nz-form-item>
        </div>



        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nzFor="contactDesignation" nzLabelAlign="left" nz-col [nzSpan]="6">Designation <span
                style="color: red;"> * </span></nz-form-label>
            <nz-form-control nzHasFeedback nzSpan="16">
              <input id="contactDesignation" nz-input formControlName="designation" placeholder="Enter Designation" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nzFor="mobile" nzLabelAlign="left" nz-col [nzSpan]="6">Mobile Number <span
                style="color: red;"> * </span></nz-form-label>
            <nz-form-control nzHasFeedback nzSpan="16">
              <nz-input-group>
                <input id="mobile" nz-input formControlName="mobileNumber" placeholder="Enter Mobile Number" />
              </nz-input-group>

            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nzFor="email" nzLabelAlign="left" nz-col [nzSpan]="6">Email ID <span style="color: red;"> *
              </span></nz-form-label>
            <nz-form-control nzHasFeedback nzSpan="16">
              <input id="email" nz-input formControlName="email" placeholder="Enter Email ID" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </nz-card>

    <!-- Address Section -->
    <nz-card nzTitle="Company Address" style="margin-top: 5px; margin-bottom: 5px;">
      <div nz-row [nzGutter]="24" style=" padding-top: 24px; border-top: 2px rgb(225, 225, 225); ">
        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nzFor="addressLine1" nzLabelAlign="left" nz-col [nzSpan]="6">Address Line 1 <span
                style="color: red;"> * </span></nz-form-label>
            <nz-form-control nzHasFeedback nzSpan="16">
              <input id="addressLine1" nz-input formControlName="addressLine1" placeholder="Enter Address Line 1" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nzFor="addressLine2" nzLabelAlign="left" nz-col [nzSpan]="6">Address Line 2</nz-form-label>
            <nz-form-control nzHasFeedback nzSpan="16">
              <input id="addressLine2" nz-input formControlName="addressLine2" placeholder="Enter Address Line 2" />
            </nz-form-control>
          </nz-form-item>
        </div>



        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nzFor="city" nzLabelAlign="left" nz-col [nzSpan]="6">City <span style="color: red;"> *
              </span> </nz-form-label>
            <nz-form-control nzHasFeedback nzSpan="16">
              <input id="city" nz-input formControlName="city" placeholder="Enter City" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nzFor="state" nzLabelAlign="left" nz-col [nzSpan]="6">State/Province <span
                style="color: red;"> * </span></nz-form-label>
            <nz-form-control nzHasFeedback nzSpan="16">
              <input id="state" nz-input formControlName="state" placeholder="Enter State" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nzFor="postalCode" nzLabelAlign="left" nz-col [nzSpan]="6">ZIP/Postal Code <span
                style="color: red;"> * </span></nz-form-label>
            <nz-form-control nzHasFeedback nz-col nzSpan="16">
              <input id="postalCode" nz-input formControlName="postalCode" placeholder="Enter ZIP Code" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="12" class="form-section">
          <nz-form-item>
            <nz-form-label nzFor="country" nzLabelAlign="left" nz-col [nzSpan]="6">Country <span style="color: red;"> *
              </span></nz-form-label>
            <nz-form-control nzHasFeedback nzSpan="16">
              <nz-select id="countryId" formControlName="country" nzShowSearch nzPlaceHolder="Select Country">

                <nz-option nzValue="India" nzLabel="India"></nz-option>
                <!-- Add more countries as needed -->
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </nz-card>

    <!-- Action Buttons -->

  </form>

</div>

<div class="form-container" *ngIf="currentStep === 2">
  <nz-card>
    <div class="classification-box">
      <strong>Bot Classification:</strong>
      <nz-tag nzColor="blue"> Domestic</nz-tag>
      <p>
        The Agent has been classified as  Domestic based on the Country and Carrier selected & will be charged at
        applicable rates.
        If you think your agent is eligible for Domestic rates, please upload proofs for your official address in the
        country you will be sending traffic to.
      </p>
    </div>
  </nz-card>

  <nz-card style="margin-top: 5px; margin-bottom: 5px;"> <div class="verification-step">
    <div class="step-number">1</div>
    <div class="verification-content">
      <h3>Verify the Legal Business Name</h3>
      <p>
        Please provide official documentation of your business’s legal name. Upload an official document that matches
        the business’s legal name such as a business license, article of incorporation, or business tax registration.
      </p>
      <div class="" nz-row [nzGutter]="12">
        <div class="" nz-col [nzSpan]="6">
          <span style="font-size: 0.8rem; font-weight: 600;">Select Document Type</span>
        </div>
        <div class="" nz-col [nzSpan]="6" *ngIf="docType=='other'">
          <span style="font-size: 0.8rem; font-weight: 600;">Specify The File Type</span>
        </div>
        <div class="" nz-col [nzSpan]="6">
          <span style="font-size: 0.8rem; font-weight: 600;">Upload Document</span>
        </div>
      </div>
      <nz-divider style="margin-top: 0;"></nz-divider>
      <div class="" nz-row [nzGutter]="12">

        <div class="" nz-col [nzSpan]="6">
          <nz-select nzPlaceHolder="Select Document Type" style="width: 100%;" nzSize="default"
            [(ngModel)]="docType">
            <nz-option nzValue="PAN card of Company" nzLabel="PAN card of Company"></nz-option>
            <nz-option nzValue="Aadhar card" nzLabel="Aadhar card"></nz-option>
            <nz-option nzValue="CST / VAT / Service Tax Certificate or letter"
              nzLabel="CST / VAT / Service Tax Certificate or letter"></nz-option>
            <nz-option nzValue="GST document" nzLabel="GST document"></nz-option>
            <nz-option nzValue="Certificate of incorporation given by Ministry of Corporate Affairs"
              nzLabel="Certificate of incorporation given by Ministry of Corporate Affairs"></nz-option>
            <nz-option nzValue="Memorandum of Association / Articles of Association" nzLabel="Memorandum of Association / Articles of Association"></nz-option>
            <nz-option nzValue="Bank account details" nzLabel="Bank account details"></nz-option>
            <nz-option nzValue="Address proof of principal place of business" nzLabel="Address proof of principal place of business"></nz-option>
            <nz-option nzValue="Property tax receipt" nzLabel="Property tax receipt"></nz-option>
            <nz-option nzValue="Municipal Khata copy" nzLabel="Municipal Khata copy"></nz-option>
            <nz-option nzValue="Electricity bill copy" nzLabel="Electricity bill copy"></nz-option>
            <nz-option nzValue="Ownership deed/document (owned property)" nzLabel="Ownership deed/document (owned property)"></nz-option>
            <nz-option nzValue="Lease / rent agreement (leased / rented property)"
              nzLabel="Lease / rent agreement (leased / rented property)"></nz-option>
            <nz-option nzValue="Consent letter / NOC from the owner (in case of consent arrangement or shared property)"
              nzLabel="Consent letter / NOC from the owner (in case of consent arrangement or shared property)"></nz-option>
            <nz-option nzValue="Other" nzLabel="Other"></nz-option>
          </nz-select>
        </div>
        <div class="" nz-col [nzSpan]="6" *ngIf="docType2=='other'">
          <input nz-input placeholder="Specify The File Type" nzSize="default" />
        </div>
        <div class="" nz-col [nzSpan]="6">
          <nz-upload   [nzAction]="apiUrl"
          [nzShowUploadList]="{ showRemoveIcon: true }"
          [nzHeaders]="{Authorization: token}"
          [nzData]="{loggedInUserName: userName,fileType: 'Business Name',fileName: fileName}"
          (nzChange)="handleUploadChange($event)"  >
            <button nz-button><i nz-icon nzType="upload">  </i> Upload Document</button>
            

          </nz-upload>


          Verify the Legal Business Name



        </div>
      </div>
    </div>
  </div>


  </nz-card>
  

  <nz-card style="margin-top: 5px; margin-bottom: 5px;">
    <div class="verification-step">
      <div class="step-number">2</div>
      <div class="verification-content">
        <h3>Verify the Business Address</h3>
        <p>Upload a document that shows both the legal name of your business and the mailing address entered while
          filling up brand details.</p>
        <div class="" nz-row [nzGutter]="12">
          <div class="" nz-col [nzSpan]="6">
            <span style="font-size: 0.8rem; font-weight: 600;">Select Document Type</span>
          </div>
          <div class="" nz-col [nzSpan]="6" *ngIf="docType2=='other'">
            <span style="font-size: 0.8rem; font-weight: 600;">Specify The File Type</span>
          </div>
          <div class="" nz-col [nzSpan]="6">
            <span style="font-size: 0.8rem; font-weight: 600;">Upload Document</span>
          </div>
        </div>
        <nz-divider style="margin-top: 0;"></nz-divider>
        <div class="" nz-row [nzGutter]="12">

          <div class="" nz-col [nzSpan]="6">
            <nz-select nzPlaceHolder="Select Document Type" style="width: 100%;" [(ngModel)]="docType2">
              <nz-option nzValue="PAN card of Company" nzLabel="PAN card of Company"></nz-option>
              <nz-option nzValue="Aadhar card" nzLabel="Aadhar card"></nz-option>
              <nz-option nzValue="CST / VAT / Service Tax Certificate or letter"
                nzLabel="CST / VAT / Service Tax Certificate or letter"></nz-option>
              <nz-option nzValue="GST document" nzLabel="GST document"></nz-option>
              <nz-option nzValue="Certificate of incorporation given by Ministry of Corporate Affairs"
                nzLabel="Certificate of incorporation given by Ministry of Corporate Affairs"></nz-option>
              <nz-option nzValue="Memorandum of Association / Articles of Association" nzLabel="Memorandum of Association / Articles of Association"></nz-option>
              <nz-option nzValue="Bank account details" nzLabel="Bank account details"></nz-option>
              <nz-option nzValue="Address proof of principal place of business" nzLabel="Address proof of principal place of business"></nz-option>
              <nz-option nzValue="Property tax receipt" nzLabel="Property tax receipt"></nz-option>
              <nz-option nzValue="Municipal Khata copy" nzLabel="Municipal Khata copy"></nz-option>
              <nz-option nzValue="Electricity bill copy" nzLabel="Electricity bill copy"></nz-option>
              <nz-option nzValue="Ownership deed/document (owned property)" nzLabel="Ownership deed/document (owned property)"></nz-option>
              <nz-option nzValue="Lease / rent agreement (leased / rented property)"
                nzLabel="Lease / rent agreement (leased / rented property)"></nz-option>
              <nz-option nzValue="Consent letter / NOC from the owner (in case of consent arrangement or shared property)"
                nzLabel="Consent letter / NOC from the owner (in case of consent arrangement or shared property)"></nz-option>
              <nz-option nzValue="Other" nzLabel="Other"></nz-option>

            </nz-select>
          </div>
          <div class="" nz-col [nzSpan]="6" *ngIf="docType=='other'">
            <input nz-input placeholder="Specify The File Type" nzSize="default" />
          </div>

          <div class="" nz-col [nzSpan]="6">
            <nz-upload   [nzAction]="apiUrl"
            [nzShowUploadList]="{ showRemoveIcon: true }"
            [nzHeaders]="{Authorization: token}"
            [nzData]="{loggedInUserName: userName,fileType: 'Business Address',fileName: fileName}"
            (nzChange)="handleUploadChange1($event)"  >
              <button nz-button><i nz-icon nzType="upload">  </i> Upload Document</button>
              

            </nz-upload>
          </div>
        </div>
      </div>
    </div>
  </nz-card>

</div>

<div class="step-actions">
  <button nz-button (click)="prevStep()">Back</button>

  <button nz-button nzType="primary" (click)="nextStep()" *ngIf="currentStep!=2">Next</button>
  <!-- <button nz-button nzType="primary"  *ngIf="currentStep!=2">Next</button> -->
  <button nz-button nzType="primary" *ngIf="currentStep==2" (click)="onSumbit()">Submit</button>

</div>